import { React, useRef, useState, useEffect } from "react";

import logo from "../Images/logo.png";

import "./new-register.css";
import "./new-redeemption.css";

import "bootstrap/dist/css/bootstrap.min.css";
import secureLocalStorage from "react-secure-storage";

import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet";

import UserformService from "../services/userform.service";

import $ from "jquery";

import { toast } from "react-toastify";
import { useLayoutEffect } from "react";
import "select2/dist/css/select2.min.css";
import "select2";

function RegisterForm(props) {
  const TITLE = process.env.REACT_APP_API_SITE_TITLE + " | Registration Form";

  const [fields, setFields] = useState({
    fname: "",
    lname: "",
    emailid: "",
    phone: "",
    address: "",
    store_location: "",
    // mattress_model: "",
    buy_mattress: "",
    sales_name_f: "",
    sales_name_l: "",
    // question1: "",
    i_agree: "",
  });

  const [errors, setErrors] = useState({});

  const [states, setStates] = useState([]);
  const [locations, setLocations] = useState([]);
  const [loading, setLoading] = useState(false);

  const [value_userform, setValue_userform] = useState([]);

  const navigate = useNavigate();

  secureLocalStorage.removeItem("registerform");
  useEffect(() => {
    async function getLocations() {
      let errors = {};

      try {
        const response = await UserformService.getStoreLocation();

        var locations = response.data.response;
        const results = [];
        locations.map((value) => {
          return results.push({
            value: value.id,
            label: value.store_name,
          });
        });
        await setLocations([...results]);

        errors["voucher"] = response.data.response;
      } catch (err) {
        if (err.status === 429 || err.status === "429") {
          alert("Max Limit Reached. Please wait.");
        }
      }
    }
    getLocations();
  }, []);
  const ref = useRef();

  const pasted = (e) => {
    e.preventDefault();
    return false;
  };

  const onlyNumbers = (evt) => {
    const { name, value } = evt.target;
    evt.target.value = evt.target.value.replace(/[^0-9]+/g, "");

    setFields((prevValue) => {
      return {
        ...prevValue,
        [name]: evt.target.value,
      };
    });
  };

  const handleChange = (e) => {
    let { value, name } = e.target;
    if (name === "state" && value === "true") {
      value = "";
    }

    if (name === "i_agree") {
      value = e.target.checked;
    }
    setFields((prevValue) => {
      return {
        ...prevValue,
        [name]: value,
      };
    });
  };
  const saveErrors = (err) => {
    setErrors(err);
  };

  const submituserRegistrationForm = (e) => {
    e.preventDefault();
    let data = {
      first_name: fields?.fname,
      last_name: fields?.lname,
      email: fields?.emailid,
      phone: fields?.phone,
      address1: fields?.address,
      store_id: fields?.store_location,
      // mattress_model: fields?.mattress_model,
      buy_mattress: fields?.buy_mattress,
      sales_fname: fields?.sales_name_f,
      sales_lname: fields?.sales_name_l,
      // question1: fields?.question1,
      i_agree: fields?.i_agree,
    };

    try {
      setLoading(true);
      const responseuserform = UserformService.regData(data);
      responseuserform
        .then((response) => {
          var valueUserform = response?.data?.status;
          setValue_userform(valueUserform);

          secureLocalStorage.setItem(
            "registerform",
            JSON.stringify({
              first_name: fields?.fname,
              last_name: fields?.lname,
              email: fields?.emailid,
              phone: fields?.phone,
              address1: fields?.address,
              store_id: fields?.store_location,
              // mattress_model: fields?.mattress_model,
              buy_mattress: fields?.buy_mattress,
              sales_fname: fields?.sales_name_f,
              sales_lname: fields?.sales_name_l,
              // question1: fields?.question1,
              i_agree: fields?.i_agree,
            }),
          );
          localStorage.removeItem("return_page");
          localStorage.setItem("isRegister", true);
          navigate("/register/registration-thankyou");

          if (value_userform?.includes("redirect")) {
          }
          setLoading(false);
        })
        .catch((err) => {
          console.log(err);
          setLoading(false);

          if (
            err?.response?.data?.message &&
            typeof err?.response?.data?.message === "string"
          ) {
            toast.error(err?.response?.data?.message, {
              position: "top-center",
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });
          }

          let errorData = {};

          errorData["fname"] =
            err?.response?.data &&
            err?.response?.data?.first_name &&
            err?.response?.data?.first_name[0];
          errorData["lname"] =
            err?.response?.data &&
            err?.response?.data?.last_name &&
            err?.response?.data?.last_name[0];
          errorData["emailid"] =
            err?.response?.data &&
            err?.response?.data?.email &&
            err?.response?.data?.email[0];
          errorData["phone"] =
            err?.response?.data &&
            err?.response?.data?.phone &&
            err?.response?.data?.phone[0];
          errorData["address"] =
            err?.response?.data &&
            err?.response?.data?.address1 &&
            err?.response?.data?.address1[0];
          errorData["store_location"] =
            err?.response?.data &&
            err?.response?.data?.store_id &&
            err?.response?.data?.store_id[0];
          errorData["mattress_model"] =
            err?.response?.data &&
            err?.response?.data?.mattress_model &&
            err?.response?.data?.mattress_model[0];
          errorData["buy_mattress"] =
            err?.response?.data &&
            err?.response?.data?.buy_mattress &&
            err?.response?.data?.buy_mattress[0];
          errorData["question1"] =
            err?.response?.data &&
            err?.response?.data?.question1 &&
            err?.response?.data?.question1[0];
          errorData["sales_name_f"] =
            err?.response?.data &&
            err?.response?.data?.sales_fname &&
            err?.response?.data?.sales_fname[0];
          errorData["sales_name_l"] =
            err?.response?.data &&
            err?.response?.data?.sales_lname &&
            err?.response?.data?.sales_lname[0];
          errorData["i_agree"] =
            err?.response?.data &&
            err?.response?.data.i_agree &&
            err?.response?.data.i_agree[0];

          saveErrors(errorData);
          setTimeout(() => {
            ref?.current?.focus();
          }, 200);
        });
    } catch (err) {
      alert(err);
      if (err.response.status === 429 || err.response.status === "429") {
        alert("Max Limit Reached. Please wait.");
      }
      let errorData = {};
      errorData["fname"] = err?.response?.data?.message.fname[0];
      errorData["lname"] = err?.response?.data?.message.lname[0];
      errorData["emailid"] = err?.response?.data?.message.emailid[0];
      errorData["phone"] = err?.response?.data?.message.phone[0];
      errorData["address"] = err?.response?.data?.message.address[0];
      errorData["store_location"] =
        err?.response?.data?.message.store_location[0];
      errorData["mattress_model"] =
        err?.response?.data?.message.mattress_model[0];
      errorData["buy_mattress"] = err?.response?.data?.message.buy_mattress[0];
      errorData["question1"] = err?.response?.data?.message.question1[0];
      errorData["sales_name_f"] = err?.response?.data?.message.sales_name_f[0];
      errorData["sales_name_l"] = err?.response?.data?.message.sales_name_l[0];
      errorData["i_agree"] = err?.response?.data?.message.i_agree[0];

      saveErrors(errorData);
    }
  };

  const Select2Field = ({ name, label, options, value }) => {
    const selectRef = useRef();

    useLayoutEffect(() => {
      const $select = $(selectRef.current);

      $select.select2();

      $select.on("change", (event) => {
        const selectedValue = $(event.target).val();
        setFields((prevValue) => {
          return {
            ...prevValue,
            [name]: selectedValue,
          };
        });
      });

      return () => {
        $select.select2("destroy");
        $select.off("change");
      };
    }, []);

    return (
      <>
        <select
          ref={selectRef}
          name={name}
          className="form-select register-select2"
          value={value || ""}
          id={name}
        >
          <option value="" disabled={true} selected={true}>
            Select {label}
          </option>
          {options.map((opt, index) => (
            <option key={index} value={opt.value}>
              {opt.label}
            </option>
          ))}
        </select>
      </>
    );
  };

  return (
    <>
      <Helmet>
        <title>{TITLE}</title>
      </Helmet>
      <section className="form-body-center form-section-bg new-register">
        <div className="container">
          <div className="row gy-4 align-items-center">
            <div className="col-12 col-md-12 col-xl-12">
              <div className="register-logo">
                <div className="svg-logo">
                  <svg
                    width={118}
                    height={48}
                    viewBox="0 0 118 48"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g>
                      <path
                        id="Vector"
                        d="M73.2142 12.1389C71.9314 12.1389 70.7362 12.5179 69.7287 13.1558C69.8602 12.4674 69.9353 11.76 69.9353 11.0337C69.9353 4.93895 65.0418 0 59.0032 0C52.9646 0 48.0711 4.93895 48.0711 11.0337C48.0711 11.76 48.1462 12.4674 48.2776 13.1558C47.2639 12.5116 46.0749 12.1389 44.7921 12.1389C41.169 12.1389 38.2341 15.1011 38.2341 18.7579C38.2341 21.9979 40.5432 24.6947 43.5907 25.2632C42.3329 24.2526 41.5131 22.7116 41.5131 20.9684C41.5131 17.9242 43.9599 15.4484 46.9823 15.4484C47.7833 15.4484 48.5404 15.6316 49.2288 15.9474C49.7482 16.1874 50.2175 16.5032 50.6305 16.8884C50.4678 16.3389 50.3551 15.7642 50.2988 15.1705C50.2738 14.8989 50.255 14.6211 50.255 14.3432C50.255 9.46737 54.1723 5.51368 59.0032 5.51368C63.8341 5.51368 67.7513 9.46737 67.7513 14.3432C67.7513 14.6211 67.7326 14.8989 67.7075 15.1705C67.6512 15.7642 67.5386 16.3326 67.3759 16.8884C67.7951 16.5095 68.2645 16.1874 68.7776 15.9474C69.4659 15.6316 70.2231 15.4484 71.0241 15.4484C74.0402 15.4484 76.4932 17.9179 76.4932 20.9684C76.4932 22.7179 75.6735 24.2526 74.4157 25.2632C77.4632 24.6947 79.7722 21.9979 79.7722 18.7579C79.7722 15.1011 76.8374 12.1389 73.2142 12.1389Z"
                        fill="white"
                      />
                      <g id="Group">
                        <path
                          id="Vector_2"
                          d="M0 38.0653H3.36034C6.40155 38.0653 8.50411 40.1747 8.50411 42.9221V42.9474C8.50411 45.6948 6.40155 47.8295 3.36034 47.8295H0V38.059V38.0653ZM3.36034 46.8126C5.80707 46.8126 7.37148 45.139 7.37148 42.9726V42.9474C7.37148 40.7811 5.80707 39.0821 3.36034 39.0821H1.09508V46.8126H3.36034Z"
                          fill="white"
                        />
                        <path
                          id="Vector_3"
                          d="M12.5716 38.0653H16.7329C17.9218 38.0653 18.8792 38.4253 19.4862 39.0443C19.9556 39.5179 20.2309 40.2 20.2309 40.9706V40.9958C20.2309 42.6127 19.1233 43.5664 17.6027 43.8443L20.5751 47.8358H19.2359L16.4263 44.04H13.6604V47.8358H12.5653V38.0653H12.5716ZM16.639 43.0422C18.0908 43.0422 19.1296 42.2906 19.1296 41.0337V41.0085C19.1296 39.8085 18.2159 39.0822 16.6515 39.0822H13.6666V43.0485H16.639V43.0422Z"
                          fill="white"
                        />
                        <path
                          id="Vector_4"
                          d="M24.3546 38.0653H31.3506V39.0695H25.4434V42.4042H30.7249V43.4084H25.4434V46.8253H31.4195V47.8295H24.3546V38.059V38.0653Z"
                          fill="white"
                        />
                        <path
                          id="Vector_5"
                          d="M39.1477 37.9958H40.1677L44.5793 47.8358H43.4029L42.2703 45.2527H37.0013L35.8562 47.8358H34.7361L39.1477 37.9958ZM41.8447 44.2611L39.6483 39.278L37.4331 44.2611H41.8447Z"
                          fill="white"
                        />
                        <path
                          id="Vector_6"
                          d="M48.1712 38.0653H49.2788L52.8081 43.3958L56.3311 38.0653H57.4387V47.8358H56.3436V39.9221L52.8143 45.1579H52.758L49.2287 39.9348V47.8358H48.1649V38.0653H48.1712Z"
                          fill="white"
                        />
                        <path
                          id="Vector_7"
                          d="M61.5312 42.9727V42.9474C61.5312 40.1811 63.5774 37.8948 66.4246 37.8948C68.183 37.8948 69.2343 38.52 70.198 39.4421L69.4533 40.2506C68.6398 39.4674 67.7262 38.9116 66.4121 38.9116C64.2657 38.9116 62.6638 40.6674 62.6638 42.9158V42.9411C62.6638 45.2021 64.2783 46.9769 66.4121 46.9769C67.7387 46.9769 68.6085 46.459 69.5347 45.5685L70.2543 46.2821C69.2468 47.3179 68.1392 48 66.3808 48C63.5899 48 61.5249 45.7832 61.5249 42.9727H61.5312Z"
                          fill="white"
                        />
                        <path
                          id="Vector_8"
                          d="M73.9213 38.0653H75.0163V46.819H80.4667V47.8358H73.9275V38.0653H73.9213Z"
                          fill="white"
                        />
                        <path
                          id="Vector_9"
                          d="M83.1576 42.9727V42.9474C83.1576 40.2506 85.16 37.8948 88.1074 37.8948C91.0547 37.8948 93.0321 40.2253 93.0321 42.9221V42.9474C93.0321 45.6379 91.0297 48 88.0823 48C85.135 48 83.1576 45.6695 83.1576 42.9727ZM91.8995 42.9727V42.9474C91.8995 40.7306 90.2975 38.9116 88.0823 38.9116C85.8671 38.9116 84.2902 40.699 84.2902 42.9158V42.9411C84.2902 45.1579 85.8922 46.9769 88.1074 46.9769C90.3226 46.9769 91.8995 45.1895 91.8995 42.9727Z"
                          fill="white"
                        />
                        <path
                          id="Vector_10"
                          d="M96.9619 43.7432V38.0653H98.057V43.6737C98.057 45.7832 99.1646 46.9706 101.017 46.9706C102.869 46.9706 103.933 45.8843 103.933 43.7432V38.0653H105.028V43.6611C105.028 46.5095 103.407 47.9874 100.992 47.9874C98.5764 47.9874 96.9682 46.5095 96.9682 43.7432H96.9619Z"
                          fill="white"
                        />
                        <path
                          id="Vector_11"
                          d="M109.496 38.0653H112.856C115.897 38.0653 118 40.1747 118 42.9221V42.9474C118 45.6948 115.897 47.8295 112.856 47.8295H109.496V38.059V38.0653ZM112.856 46.8126C115.303 46.8126 116.867 45.139 116.867 42.9726V42.9474C116.867 40.7811 115.303 39.0821 112.856 39.0821H110.591V46.8126H112.856Z"
                          fill="white"
                        />
                      </g>
                    </g>
                    <defs>
                      <clipPath id="clip0_260_6701">
                        <rect width={118} height={48} fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                </div>
                <img
                  src={logo}
                  alt="city-logo.png"
                  className="img-fluid"
                  width="360"
                  height="118"
                />
              </div>
            </div>
            <div className="col-12 col-md-12 col-xl-12">
              <div className="d-flex justify-content-center text-bg-primary top-bg">
                <div className="col-12 col-xl-12 text-center">
                  <h2 className="form-heading">
                    Enter The Rest Test Perfect Posture to win a $2,500 JV
                    Schultz Shopping Spree!
                  </h2>
                </div>
              </div>
            </div>

            <div className="col-12 col-md-12 col-xl-12">
              <div className="card border-0 rounded-4 p-0">
                <div className="card-body p-3 p-md-4 p-xl-5">
                  <form
                    onSubmit={submituserRegistrationForm}
                    name="userRegistrationForm"
                  >
                    <div className="row gy-3 overflow-hidden">
                      {/* <div className="col-lg-4 col-md-6 col-sm-12 mb-3">
                        <div className="form-floating ">
                          <i className="zmdi zmdi-account-circle icon-position"></i>

                          <input
                            type="text"
                            className="form-control"
                            style={
                              errors.sales_name
                                ? { border: "1px solid red" }
                                : null
                            }
                            name="sales_name"
                            placeholder="Sales Associate Name"
                            ref={errors.sales_name ? ref : null}
                            value={fields.sales_name || ""}
                            autoFocus=""
                            onChange={handleChange}
                          />

                          <label className="form-label">
                            Sales Associate Name
                            <span className="gl-form-asterisk"></span>
                          </label>
                        </div>
                        <div className="errorMsg">{errors.sales_name}</div>
                      </div> */}

                      <div className="col-lg-4 col-md-6 col-sm-12 mb-3">
                        <div className="form-floating ">
                          <i className="zmdi zmdi-account-o icon-position"></i>

                          <input
                            type="text"
                            className="form-control"
                            style={
                              errors.fname ? { border: "1px solid red" } : null
                            }
                            name="fname"
                            placeholder="Customer First Name"
                            ref={errors.fname ? ref : null}
                            value={fields.fname || ""}
                            autoFocus=""
                            onChange={handleChange}
                          />

                          <label className="form-label">
                            Customer First Name
                            <span className="gl-form-asterisk"></span>
                          </label>
                        </div>
                        <div className="errorMsg">{errors.fname}</div>
                      </div>
                      <div className="col-lg-4 col-md-6 col-sm-12 mb-3">
                        <div className="form-floating">
                          <i className="zmdi zmdi-account-o icon-position"></i>

                          <input
                            type="text"
                            className="form-control"
                            name="lname"
                            style={
                              errors.lname && !errors.fname
                                ? { border: "1px solid red" }
                                : null
                            }
                            placeholder="Customer Last Name"
                            value={fields.lname || ""}
                            ref={errors.lname && !errors.fname ? ref : null}
                            onChange={handleChange}
                          />

                          <label className="form-label">
                            Customer Last Name
                            <span className="gl-form-asterisk"></span>
                          </label>
                        </div>
                        <div className="errorMsg">
                          {errors.lname && !errors.fname ? errors.lname : null}
                        </div>
                      </div>
                      <div className="col-lg-4 col-md-6 col-sm-12 mb-3">
                        <div className="form-floating ">
                          <i className="zmdi zmdi-email-open icon-position"></i>

                          <input
                            type="text"
                            className="form-control"
                            name="emailid"
                            ref={
                              errors.emailid && !errors.lname && !errors.fname
                                ? ref
                                : null
                            }
                            style={
                              errors.emailid && !errors.lname && !errors.fname
                                ? { border: "1px solid red" }
                                : null
                            }
                            placeholder="Customer Email"
                            value={fields.emailid || ""}
                            onChange={handleChange}
                          />

                          <label className="form-label">
                            Customer Email
                            <span className="gl-form-asterisk"></span>
                          </label>
                        </div>
                        <div className="errorMsg">
                          {errors.emailid && !errors.lname && !errors.fname
                            ? errors.emailid
                            : null}
                        </div>
                      </div>
                      <div className="col-lg-4 col-md-6 col-sm-12 mb-3">
                        <div className="form-floating ">
                          <i className="zmdi zmdi-local-phone icon-position"></i>

                          <input
                            type="text"
                            name="phone"
                            style={
                              errors.phone &&
                              !errors.emailid &&
                              !errors.lname &&
                              !errors.fname
                                ? { border: "1px solid red" }
                                : null
                            }
                            className="form-control"
                            placeholder="Customer Phone#"
                            value={fields.phone || ""}
                            ref={
                              errors.phone &&
                              !errors.emailid &&
                              !errors.lname &&
                              !errors.fname
                                ? ref
                                : null
                            }
                            onChange={handleChange}
                            onKeyUp={onlyNumbers}
                            onPaste={pasted}
                            maxLength={10}
                          />

                          <label className="form-label">
                            Customer Phone#
                            <span className="gl-form-asterisk"></span>
                          </label>
                        </div>
                        <div className="errorMsg">
                          {errors.phone &&
                          !errors.emailid &&
                          !errors.lname &&
                          !errors.fname
                            ? errors.phone
                            : null}
                        </div>
                      </div>
                      <div className="col-lg-4 col-md-6 col-sm-12 mb-3">
                        <div className="form-floating ">
                          <i className="zmdi zmdi-store  icon-position"></i>

                          <input
                            type="text"
                            className="form-control"
                            placeholder="Customer Address"
                            name="address"
                            style={
                              errors.address &&
                              !errors.phone &&
                              !errors.emailid &&
                              !errors.lname &&
                              !errors.fname
                                ? { border: "1px solid red" }
                                : null
                            }
                            value={fields.address || ""}
                            ref={
                              errors.address &&
                              !errors.phone &&
                              !errors.emailid &&
                              !errors.lname &&
                              !errors.fname
                                ? ref
                                : null
                            }
                            onChange={handleChange}
                          />

                          <label className="form-label">
                            Address
                            <span className="gl-form-asterisk"></span>
                          </label>
                        </div>
                        <div className="errorMsg">
                          {errors.address &&
                          !errors.phone &&
                          !errors.emailid &&
                          !errors.lname &&
                          !errors.fname
                            ? errors.address
                            : null}
                        </div>
                      </div>
                      <div className="col-lg-4 col-md-6 col-sm-12 mb-3">
                        <div className="form-floating ">
                          <i className="zmdi zmdi-pin icon-position"></i>

                          <Select2Field
                            name="store_location"
                            label="Store"
                            options={locations}
                            value={fields["store_location"] || ""}
                          />

                          <label className="form-label form-label-select">
                            Visited Store
                            <span className="gl-form-asterisk"></span>
                          </label>
                        </div>
                        <div className="errorMsg">
                          {errors.store_location &&
                          !errors.address &&
                          !errors.phone &&
                          !errors.emailid &&
                          !errors.lname &&
                          !errors.fname
                            ? errors.store_location
                            : null}
                        </div>
                      </div>
                      {/* <div className="col-lg-4 col-md-6 col-sm-12 mb-3">
                        <div className="form-floating ">
                          <i className="zmdi zmdi-star icon-position"></i>

                          <Select2Field
                            name="mattress_model"
                            label="an Option"
                            options={[
                              {
                                value: "Helix Midnight Elite",
                                label: "Helix Midnight Elite",
                              },
                              {
                                value: "Helix Twilight Elite",
                                label: "Helix Twilight Elite",
                              },
                              {
                                value: "Helix Midnight Luxe",
                                label: "Helix Midnight Luxe",
                              },
                            ]}
                            value={fields["mattress_model"] || ""}
                          />

                          <label className="form-label form-label-select">
                            Which mattress model did you prefer?
                            <span className="gl-form-asterisk"></span>
                          </label>
                        </div>
                        <div className="errorMsg">
                          {errors.mattress_model &&
                          !errors.store_location &&
                          !errors.address &&
                          !errors.phone &&
                          !errors.emailid &&
                          !errors.lname &&
                          !errors.fname
                            ? errors.mattress_model
                            : null}
                        </div>
                      </div> */}
                      <div className="col-lg-4 col-md-6 col-sm-12 mb-3">
                        <div
                          className="form-floating "
                          title="Did you visit with the intention of buying a
                            mattress today?"
                        >
                          <i className="zmdi zmdi-walk icon-position"></i>

                          <Select2Field
                            name="buy_mattress"
                            label="Option"
                            options={[
                              {
                                value: "yes",
                                label: "Yes",
                              },
                              {
                                value: "no",
                                label: "No",
                              },
                            ]}
                            value={fields["buy_mattress"] || ""}
                          />

                          <label
                            className="form-label form-label-select"
                            title="Did you visit with the intention of buying a
                            mattress today?"
                          >
                            Did you visit with the intention of buying a
                            mattress today?
                            <span className="gl-form-asterisk"></span>
                          </label>
                        </div>
                        <div className="errorMsg">
                          {errors.buy_mattress &&
                          !errors.mattress_model &&
                          !errors.store_location &&
                          !errors.address &&
                          !errors.phone &&
                          !errors.emailid &&
                          !errors.lname &&
                          !errors.fname
                            ? errors.buy_mattress
                            : null}
                        </div>
                      </div>
                      <div className="col-lg-4 col-md-6 col-sm-12 mb-3">
                        <div className="form-floating ">
                          <i className="zmdi zmdi-account-circle icon-position"></i>

                          <input
                            type="text"
                            className="form-control"
                            style={
                              errors.sales_name_f &&
                              !errors.buy_mattress &&
                              !errors.mattress_model &&
                              !errors.store_location &&
                              !errors.address &&
                              !errors.phone &&
                              !errors.emailid &&
                              !errors.lname &&
                              !errors.fname
                                ? { border: "1px solid red" }
                                : null
                            }
                            name="sales_name_f"
                            placeholder="Sales Associate First Name"
                            ref={
                              errors.name &&
                              !errors.mattress_model &&
                              !errors.store_location &&
                              !errors.buy_mattress &&
                              !errors.address &&
                              !errors.phone &&
                              !errors.emailid &&
                              !errors.lname &&
                              !errors.fname
                                ? ref
                                : null
                            }
                            value={fields.sales_name_f || ""}
                            autoFocus=""
                            onChange={handleChange}
                          />

                          <label className="form-label">
                            Sales Associate First Name
                            <span className="gl-form-asterisk"></span>
                          </label>
                        </div>
                        <div className="errorMsg">
                          {errors.sales_name_f &&
                          !errors.mattress_model &&
                          !errors.buy_mattress &&
                          !errors.store_location &&
                          !errors.address &&
                          !errors.phone &&
                          !errors.emailid &&
                          !errors.lname &&
                          !errors.fname
                            ? errors.sales_name_f
                            : null}
                        </div>
                      </div>
                      <div className="col-lg-4 col-md-6 col-sm-12 mb-3">
                        <div className="form-floating ">
                          <i className="zmdi zmdi-account-circle icon-position"></i>

                          <input
                            type="text"
                            className="form-control"
                            style={
                              errors.sales_name_l &&
                              !errors.sales_name_f &&
                              !errors.mattress_model &&
                              !errors.buy_mattress &&
                              !errors.store_location &&
                              !errors.address &&
                              !errors.phone &&
                              !errors.emailid &&
                              !errors.lname &&
                              !errors.fname
                                ? { border: "1px solid red" }
                                : null
                            }
                            name="sales_name_l"
                            placeholder="Sales Associate Last Name"
                            ref={
                              errors.name &&
                              !errors.sales_name_f &&
                              !errors.mattress_model &&
                              !errors.store_location &&
                              !errors.buy_mattress &&
                              !errors.address &&
                              !errors.phone &&
                              !errors.emailid &&
                              !errors.lname &&
                              !errors.fname
                                ? ref
                                : null
                            }
                            value={fields.sales_name_l || ""}
                            autoFocus=""
                            onChange={handleChange}
                          />

                          <label className="form-label">
                            Sales Associate Last Name
                            <span className="gl-form-asterisk"></span>
                          </label>
                        </div>
                        <div className="errorMsg">
                          {errors.sales_name_l &&
                          !errors.sales_name_f &&
                          !errors.buy_mattress &&
                          !errors.mattress_model &&
                          !errors.store_location &&
                          !errors.address &&
                          !errors.phone &&
                          !errors.emailid &&
                          !errors.lname &&
                          !errors.fname
                            ? errors.sales_name_l
                            : null}
                        </div>
                      </div>
                      {/* <div className="col-lg-4 col-md-6 col-sm-12 mb-3">
                        <div className="form-floating ">
                          <i className="zmdi zmdi-pin icon-position"></i>

                          <Select2Field
                            name="question1"
                            label="an Option"
                            options={[
                              {
                                value: "Advertisement (online or TV)",
                                label: "Advertisement (online or TV)",
                              },
                              {
                                value: "Google / online search",
                                label: "Google / online search",
                              },
                              {
                                value: "In-store / showroom",
                                label: "In-store / showroom",
                              },
                              { value: "Podcast", label: "Podcast" },
                              {
                                value: "Recommendation from friend/family",
                                label: "Recommendation from friend/family",
                              },
                              {
                                value: "Review website",
                                label: "Review website",
                              },
                              { value: "Social media", label: "Social media" },
                              {
                                value: "YouTube video",
                                label: "YouTube video",
                              },
                            ]}
                            value={fields["question1"] || ""}
                          />

                          <label className="form-label form-label-select">
                            How did you hear about Helix?
                            <span className="gl-form-asterisk"></span>
                          </label>
                        </div>
                        <div className="errorMsg">
                          {errors.question1 &&
                          !errors.sales_name_l &&
                          !errors.buy_mattress &&
                          !errors.sales_name_f &&
                          !errors.mattress_model &&
                          !errors.store_location &&
                          !errors.address &&
                          !errors.phone &&
                          !errors.emailid &&
                          !errors.lname &&
                          !errors.fname
                            ? errors.question1
                            : null}
                        </div>
                      </div> */}
                      <div className="col-md-12 col-sm-12">
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            name="i_agree"
                            value={fields.i_agree}
                            onChange={handleChange}
                            id="myCheck"
                          />
                          <label className="form-check-label" htmlFor="myCheck">
                            I give JV Schultz permission to use my information
                            for future promotional initiatives
                          </label>
                          <div className="errorMsg">
                            {errors.i_agree &&
                            !errors.question1 &&
                            !errors.sales_name_l &&
                            !errors.sales_name_f &&
                            !errors.mattress_model &&
                            !errors.store_location &&
                            !errors.buy_mattress &&
                            !errors.address &&
                            !errors.phone &&
                            !errors.emailid &&
                            !errors.lname &&
                            !errors.fname
                              ? errors.i_agree
                              : null}
                          </div>
                        </div>
                      </div>

                      <div className="col-lg-4 col-md-5 col-sm-12 ">
                        <div className="d-grid">
                          <button
                            className="btn btn-primary btn-lg "
                            type="submit"
                          >
                            Submit
                          </button>
                        </div>
                      </div>
                      <div className="col-12">
                        <div className="alert alert-info alert-info-custom">
                          Limit 1 per household, while supplies last. Some
                          restrictions apply, see store for detail.
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <div className={`loader ${loading ? "in" : ""}`}>
        <div className="spinner-border main-spin"></div>
      </div>

      {/* <Footer2 /> */}
    </>
  );
}
export default RegisterForm;
